import { getAssetBlob, putAssetBlob } from "../../db/database";

export const MARKDOWN_ASSET_PREFIX = "kimnote-asset://";
const MARKDOWN_ASSET_PATTERN = /kimnote-asset:\/\/([a-f0-9]{64})/gi;
const previewUrlCache = new Map<string, string>();

export function markdownAssetUrl(hash: string): string {
  return `${MARKDOWN_ASSET_PREFIX}${hash}`;
}

export function markdownAssetHash(source?: string): string | undefined {
  if (!source?.startsWith(MARKDOWN_ASSET_PREFIX)) return undefined;
  const hash = source.slice(MARKDOWN_ASSET_PREFIX.length).toLowerCase();
  return /^[a-f0-9]{64}$/.test(hash) ? hash : undefined;
}

export function getMarkdownAssetHashes(markdown: string): string[] {
  const hashes = new Set<string>();
  for (const match of markdown.matchAll(MARKDOWN_ASSET_PATTERN)) hashes.add(match[1].toLowerCase());
  return [...hashes];
}

export async function storeMarkdownImage(projectId: string, image: File): Promise<string> {
  if (!image.type.startsWith("image/")) throw new Error("只能嵌入图片文件");
  const asset = await putAssetBlob(projectId, image, {
    originalName: image.name,
    mimeType: image.type,
  });
  return markdownAssetUrl(asset.hash);
}

export async function resolveMarkdownImageSource(source: string): Promise<string> {
  const hash = markdownAssetHash(source);
  if (!hash) return source;
  const cached = previewUrlCache.get(hash);
  if (cached) return cached;
  const blob = await getAssetBlob(hash);
  if (!blob) throw new Error("嵌入图片不存在或已被移除");
  const objectUrl = URL.createObjectURL(blob);
  previewUrlCache.set(hash, objectUrl);
  return objectUrl;
}

if (typeof window !== "undefined") {
  window.addEventListener("beforeunload", () => {
    for (const url of previewUrlCache.values()) URL.revokeObjectURL(url);
    previewUrlCache.clear();
  }, { once: true });
}
